<template>
  <b-overlay :show="loadingSensor">
    <div class="row m-0">
      <div class="col-lg-4 col-md-12 p-2">
        <LittleCard
            variant="danger"
            :text="$t('monitoramento.resumo.tabs.temperatura.little_cards.temperatura')"
            :value="average(sensor, 'temperature')"
            valueDescription="º C"
            icon="thermometer-half"/>
      </div>
      <!--
      <div class="col-lg-4 col-md-12 p-2">
        <LittleCard
            variant="primary"
            :text="$t('monitoramento.resumo.tabs.temperatura.little_cards.umidade')"
            :value="average(sensor, 'humidity')"
            valueDescription="%"
            icon="tint"/>
      </div>
      -->
      <div class="col-lg-4 col-md-12 p-2">
        <LittleCard v-if="periodo.selected.text === $t('monitoramento.resumo.tabs.latencia.little_cards.personalizado')"
                    variant="secondary" text="Período" icon="clock">
          <DatePicker id="period-custom" v-model="periodo.datepicker" @change="selectDatepicker" range/>
          <template v-slot:icon>
            <b-btn variant="outline-danger" @click="loadData(periodo.options[0])">
              {{ $t('monitoramento.resumo.tabs.latencia.little_cards.cancelar') }}
            </b-btn>
          </template>
        </LittleCard>
        <LittleCard v-else variant="secondary" text="Período" icon="clock">
          <b-dropdown variant="outline-secondary" size="sm" :text="periodo.selected.text">
            <b-dropdown-item v-for="periodo in periodo.options" @click="loadData(periodo)">
              {{ periodo.text }}
            </b-dropdown-item>
          </b-dropdown>
        </LittleCard>
      </div>
    </div>
    <div style="width: 90%;">
      <line-chart :data="temperatureHumidity"/>
    </div>
  </b-overlay>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import LittleCard from "@/components/LittleCard";
import moment from "moment";
import DatePicker from 'vue2-datepicker';

export default {
  name: "Temperature",
  components: {LittleCard, DatePicker},
  computed: {
    ...mapGetters({
      vns: 'vns/current',
      sensor: 'vns/monitor/getSensor',
    }),
    temperatureHumidity() {
      const temperatureData = {
        name: this.$t('monitoramento.resumo.tabs.temperatura.little_cards.temperatura'),
        data: {}
      }
      /*
      const humidityData = {
        name: this.$t('monitoramento.resumo.tabs.temperatura.little_cards.umidade'),
        data: {}
      }
      */
      if (this.sensor && Array.isArray(this.sensor)) {
        this.sensor.map(sensor => {
          // When period equal a day, get hours average
          const period = sensor.created_at ? moment(sensor.created_at) : moment(sensor.hour)
          temperatureData.data[period] = sensor.temperature ? sensor.temperature.toFixed(2) : null
          // humidityData.data[period] = sensor.humidity ? sensor.humidity.toFixed(2) : null
        })
      }
      // return [humidityData, temperatureData]
      return [{}, temperatureData]
    }
  },
  data() {
    return {
      loadingSensor: false,
      periodo: {
        datepicker: null,
        selected: {
          text: '10 ' + this.$t('monitoramento.resumo.tabs.latencia.little_cards.minutos'),
          value: {minutes: 10}
        },
        options: [
          {text: '10 ' + this.$t('monitoramento.resumo.tabs.latencia.little_cards.minutos'), value: {minutes: 10}},
          {text: '30 ' + this.$t('monitoramento.resumo.tabs.latencia.little_cards.minutos'), value: {minutes: 30}},
          {text: '1 ' + this.$t('monitoramento.resumo.tabs.latencia.little_cards.hora'), value: {minutes: 60}},
          {text: this.$t('monitoramento.resumo.tabs.latencia.little_cards.personalizado'), value: 'custom'}
        ]
      },
    }
  },
  methods: {
    ...mapActions([
      'vns/monitor/listSensor'
    ]),
    average(arrayObj, key) {
      if (arrayObj.length > 0) {
        const avg = arrayObj.reduce((a, b) => {
          if (Object.keys(a).length > 0) return a[key] + b[key]
          return a + b[key]
        }, 0) / arrayObj.length;
        return Math.round(avg * 100) / 100
      }
      return null
    },
    async loadData(periodo) {
      this.periodo.selected = periodo
      if (this.periodo.selected.value === 'custom') {
        return
      }
      let filters = {
        id: this.vns.id,
        vnsId: this.vns.id,
        ...this.periodo.selected.value
      }

      this.loadingSensor = true
      await this['vns/monitor/listSensor'](filters)
      this.loadingSensor = false
    },
    selectDatepicker(period) {
      if (period && period.length > 0) {
        period[0].setHours(0, 0, 0, 0)
        period[1].setHours(23, 59, 59, 999)

        const start_date = moment(period[0].toUTCString()).tz("America/Sao_Paulo").format()
        const end_date = moment(period[1].toUTCString()).tz("America/Sao_Paulo").format()
        this.loadData({
          text: this.$t('monitoramento.resumo.tabs.latencia.little_cards.personalizado'),
          value: {start_date, end_date}
        })
      }
    }
  },
  mounted() {
    this.$store.commit('vns/monitor/setSensor', [])
    this.loadData(this.periodo.selected)
  }
}
</script>

<style lang="scss" scoped>
/deep/ .mx-datepicker-range {
  width: 100%;
}
</style>